import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'BlackBookFilter',
	pure: false,
})
export class BlackBookFilter implements PipeTransform {
	transform(items: any[], filter: any): any {
		if (!items || !filter) {
			return items;
		}

		if (filter === 'all') return items;
		// filter items array, items which match and return true will be
		// kept, false will be filtered out
		return items.filter((item) => item.type.indexOf(filter) !== -1);
	}
}
